import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { UiFormModule } from '../../shared/ui/ui-form.module';
import { ContactPortalComponent } from './components/contact-portal/contact-portal.component';

/**
 * Pantalla de gestión del portal de un contacto. Se declara aquí, sin rutas, porque se usa en dos
 * sitios: como popup desde el menú ⋮ del listado de contactos (ContactModule) y como pestaña de la
 * ficha del contacto (CustomerPortalAdminModule, lazy).
 */
@NgModule({
  declarations: [ContactPortalComponent],
  exports: [ContactPortalComponent],
  imports: [
    CommonModule,
    UiFormModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
  ],
})
export class CustomerPortalSharedModule {}
